// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2TTU7","itemTitle":"ClientEmergencyInfo_itemTitle__G0cau","itemText":"ClientEmergencyInfo_itemText__1uOxS"};